import { render } from "./FormContactPreferencesView.vue?vue&type=template&id=aad26ee4"
import script from "./FormContactPreferencesView.vue?vue&type=script&lang=js"
export * from "./FormContactPreferencesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__